@let hasGeneralSettingsUpdatePermission =
  !!(hasGeneralSettingsUpdatePermission$ | async);
@let forbiddenPermissionsMessage = 'general.forbidden_action' | translate;

<div class="list-height ms-4">
  <div>
    <h4 class="mb-2">
      {{ 'page.general_settings.title' | translate }}
    </h4>
    <div class="mb-2 subtitle">
      {{ 'page.general_settings.subtitle' | translate }}
    </div>
  </div>
  @if (rootOrgUnit$ | async) {
    <div class="d-flex justify-content-between">
      <div class="w-100">
        <label class="form-label mb-0" for="companyName">
          {{ 'page.general_settings.company_name' | translate }}
        </label>
        <input
          class="br-0 rounded-0"
          nz-input
          nz-tooltip
          [disabled]="!hasGeneralSettingsUpdatePermission"
          [nzTooltipTitle]="
            !hasGeneralSettingsUpdatePermission
              ? forbiddenPermissionsMessage
              : ''
          "
          required
          [placeholder]="'general.input' | translate"
          name="companyName"
          [(ngModel)]="companyName"
          type="text"
          (blur)="onCompanyNameChange()"
        />
      </div>
    </div>
  }
  <div class="mt-3">
    <wilson-general-settings-details
      [hasGeneralSettingsUpdatePermission]="hasGeneralSettingsUpdatePermission"
      (changeInfoDetails)="addOrUpdateGeneralSettings()"
      [form]="infoDetailsForm"
    >
    </wilson-general-settings-details>
  </div>
  <div class="mt-3">
    <wilson-general-settings-address
      (changeAddress)="addOrUpdateAddressSettings()"
      [hasGeneralSettingsUpdatePermission]="hasGeneralSettingsUpdatePermission"
      [form]="addressDetailsForm"
    >
    </wilson-general-settings-address>
  </div>
  <div class="mt-3">
    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="avatar">
      {{ 'page.general_settings.company_logo' | translate }}
    </nz-form-label>
    <nz-form-control
      [nzSm]="14"
      [nzXs]="24"
      [nzErrorTip]="'page.general_settings.company_logo.error' | translate"
      [nzExtra]="
        companyLogoFileSizeStatus !== 'error'
          ? ('page.general_settings.company_logo.hint' | translate)
          : ''
      "
      nzHasFeedback
      [nzValidateStatus]="companyLogoFileSizeStatus"
    >
      <nz-upload
        class="avatar-uploader"
        nzName="avatar"
        nzListType="picture-card"
        [nzShowUploadList]="true"
        [nzBeforeUpload]="beforeUpload"
        [nzAccept]="
          'image/jpeg,image/png,image/jpg,image/gif,image/svg+xml,image/webp'
        "
        nz-tooltip
        nzTooltipPlacement="topLeft"
        [nzShowUploadList]="false"
        [nzTooltipTitle]="
          !hasGeneralSettingsUpdatePermission ? forbiddenPermissionsMessage : ''
        "
        [nzDisabled]="!hasGeneralSettingsUpdatePermission"
      >
        @if (!companyLogoUrl) {
          <span
            class="upload-icon"
            nz-icon
            [nzType]="loading ? 'loading' : 'plus'"
          ></span>
          <div class="ant-upload-text">{{ 'general.upload' | translate }}</div>
        } @else {
          <div class="image-container">
            <img [src]="companyLogoUrl" class="company-logo" />
            <div class="overlay">
              <fa-icon
                [icon]="faTrash"
                class="trash-icon"
                (click)="
                  hasGeneralSettingsUpdatePermission &&
                    removeCompanyLogo($event)
                "
              ></fa-icon>
            </div>
          </div>
        }
      </nz-upload>
    </nz-form-control>
  </div>
  <div class="mt-3">
    <wilson-general-settings-tax
      (changeVat)="addOrUpdateVatDetails()"
      [form]="vatDetailsForm"
      [hasGeneralSettingsUpdatePermission]="hasGeneralSettingsUpdatePermission"
    >
    </wilson-general-settings-tax>
  </div>
  <div class="mt-3">
    <wilson-bank-details
      (addMoreBankDetail)="addMoreBankDetails()"
      (addBankDetail)="addBankDetails($event)"
      (deleteDetails)="deleteDetails($event)"
      [bankFormArray]="bankDetailsFormArray"
      [hasGeneralSettingsUpdatePermission]="hasGeneralSettingsUpdatePermission"
    >
    </wilson-bank-details>
  </div>
</div>
